import {useState} from "react"
import { Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import {toast} from 'react-hot-toast';
import { useNavigate } from "react-router-dom";

export default function AploadBook(){
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState('');
    const [errors, setErrors] = useState({});
    const [newBook, setNewBook] = useState({
        name:'',
        thumbnailUrl : '',
        subject:'',
        book_year:'',
        grade_category:'',
        grade_level:'',
        book : '',
        thumbnail : ''
    })
    
    // const [selectedFile, setSelectedFile] = useState(null)

    const handleChange = (e)=>{
        setNewBook({...newBook, [e.target.name]: e.target.value})
    }

    const handleFileChange = (e)=>{
        //setNewPaper({...newPaper, paper: e.target.files[0]})
        const file = e.target.files[0];
        if(file){
            setNewBook({...newBook, book : file})
        } 
    }

    const handleImageChange = (e)=>{
        //setNewPaper({...newPaper, paper: e.target.files[0]})
        const imageFile = e.target.files[0];
        if(imageFile){
            setNewBook({...newBook, thumbnail : imageFile})
        } 
    }

    const handleSubmit = async (event)=>{
        const formData = new FormData()
        formData.append("subject", newBook.subject)
        formData.append("year", newBook.book_year)
        formData.append("grade_category", newBook.grade_category)
        formData.append("grade_level", newBook.grade_level)
        formData.append("book", newBook.book)
        formData.append("thumbnail", newBook.thumbnail)
        
        event.preventDefault();
        let isValid = true;
        const newErrors = {};

        if(!newBook.subject){
            newErrors.subject = 'Subject is required';
            isValid = false;
        }
        if(!newBook.book_year){
            newErrors.book_year = 'Year is required';
            isValid = false;
        }
        if(!newBook.grade_category){
            newErrors.grade_category = 'Category is required';
            isValid = false;
        }
        if(!newBook.grade_level){
            newErrors.grade_level = 'Level is required';
            isValid = false;
        }
        if(!newBook.book){
            newErrors.name = 'No File Selected';
            isValid = false;
        }
        if(!newBook.thumbnail){
            newErrors.name = 'No Cover Image Selected';
            isValid = false;
        }

        setErrors(newErrors);

        if(isValid){
            setUploadStatus('uploading');       

            const user = JSON.parse(localStorage.getItem("user"));

            console.log(user.accessToken);

            try {
                const response = await axios.post('https://coda.easylinksmw.com/api/book/addBook', formData, {
                    headers : {
                        authorization : "Bearer " + user.accessToken
                    },
                    onUploadProgress : (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setUploadProgress(percentCompleted);
                },           
            });
            setUploadStatus('success');
            console.log('Response: ', response.data);
            toast.success('Paper uploaded succcessfully')
            //navigate('/papers');
            //window.location.reload();

            setNewBook({
                name:'',
                subject:'',
                book_year:'',
                grade_category:'',
                grade_level:'',
                book : '',
                thumbnail : ''              
            });

            } catch (error) {
                // The request was made and the server responded with a status code
                setUploadStatus('failed');
                console.error('Upload error:', error);
                //console.error('Status code:', error.response.status);
                toast.error('Paper uploaded Failed. Try again')
                navigate('/create');            
            } 
        }        
    }
    
    return(
        <div style={{marginTop: 20}}>
            <div className="row">
                <div className="col-md-6 offset-md-3">
                <h3 className="text-center ">Upload new Book </h3>
                <Form encType ="multipart/form-data" method="post">
                    {/* <Form.Group className="mb-3" controlId="paper_name">
                        <Form.Label>Paper Name</Form.Label>
                        <Form.Control onChange={handleChange} name="paper_name" value={newPaper.paper_name}  type="text" placeholder="paper name" />
                    </Form.Group> */}
                    <Form.Group className="mb-3" controlId="paper_subject">
                        <Form.Label>Subject</Form.Label>
                        <Form.Control onChange={handleChange} name="subject" value={newBook.subject}  type="text" placeholder="subject" required/>
                        {errors.subject && <p className="error">{errors.subject}</p>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="phone">
                        <Form.Label>Grade Category</Form.Label>
                        <Form.Select onChange={handleChange} name="grade_category" value={newBook.grade_category}  type="text" placeholder="Category" required>
                            <option>Select Grade</option>
                            <option value="JCE">JCE</option>
                            <option value="MSCE">MSCE</option>
							<option value="PSLCE">PSLCE</option>
                        </Form.Select>
                        {errors.grade_category && <p className="error">{errors.grade_category}</p>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="year">
                        <Form.Label>Publication Year Year</Form.Label>
                        <Form.Select onChange={handleChange} name="book_year" value={newBook.paper_year}  type="number" placeholder="Year" required>
                            <option>Select Year</option>
                         	<option value="2026">2026</option>
                         	<option value="2025">2025</option>
                         	<option value="2024">2024</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                            <option value="2020">2020</option>
                            <option value="2019">2019</option>
                            <option value="2018">2018</option>
                            <option value="2017">2017</option>
                            <option value="2016">2016</option>
                            <option value="2015">2015</option>
                            <option value="2014">2014</option>
                            <option value="2013">2013</option>
                            <option value="2012">2012</option>
                            <option value="2011">2011</option>
                            <option value="2010">2010</option>
                            <option value="2009">2009</option>
                            <option value="2008">2008</option>
                            <option value="2007">2007</option>
                            <option value="2006">2006</option>
                            <option value="2005">2005</option>
                            <option value="2004">2004</option>
                            <option value="2003">2003</option>
                            <option value="2002">2002</option>
                            <option value="2001">2001</option>
                            <option value="2000">2000</option>
                        </Form.Select>
                        {errors.paper_year && <p className="error">{errors.paper_year}</p>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="grade_level">
                        <Form.Label>Level</Form.Label>
                        <Form.Select onChange={handleChange} name="grade_level" value={newBook.grade_level}  type="text" placeholder="Level" required>
                            <option>Select Level</option>
                            <option value="Form 1">Form One</option>
                            <option value="Form 2">Form Two</option>
                            <option value="Form 3">Form Three</option>
                            <option value="Form 4">Form Four</option>
							<option value="PSLCE">PSLCE</option>
                        </Form.Select>
                        {errors.grade_level && <p className="error">{errors.grade_level}</p>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="last_name">
                        <Form.Label>Upload Cover Image (Image files only)</Form.Label>
                        <Form.Control name="thumbnail" type="file" accept="image/*" onChange={handleImageChange} required/>
                        {errors.name && <p className="error">{errors.name}</p>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="last_name">
                        <Form.Label>Upload Book (PDF files only)</Form.Label>
                        <Form.Control name="book" type="file" onChange={handleFileChange} required/>
                        {errors.name && <p className="error">{errors.name}</p>}
                    </Form.Group>
                    <Button
                        style={{width:'100%', marginTop:'1rem'}} 
                        onClick={handleSubmit} 
                        variant="primary">
                        {uploadStatus === 'uploading' ? 'Uploading...' : 'Submit'}
                    </Button>
                </Form>
                {uploadStatus === 'uploading' && (
                    <div className="progress-container">
                    <progress value={uploadProgress} max="100" />
                    <span>{uploadProgress}%</span>
                    </div>
                )}
                {uploadStatus === 'success' && (
                    <div className="success-message">
                    File uploaded successfully!
                    </div>
                )}
                </div>
            </div>           
        </div>
    )
}